import {required} from "vuelidate/lib/validators";  
const StrIcDegerTablo = {
    data() {
      return {  
        
        StrIcDegerTabloData: { 
          UstId: null,
          Tabloadi: "",
          Seviye: "",
          Aktif: false,
          Sirano: "",
          Olgunluk1: "",
          Olgunluk2: "",
          Olgunluk3: "",
          Olgunluk4: "",
          Olgunluk5: "",
          Aciklama: "",
          Degerlendirmetur: 1,
          Deleted: false,
          }, 
          FormDataType:{
            Tabloadi:{FieldName:"Tabloadi",Field:"input",FieldTitle:this.$t('StrIcDegerTablo.AddEdit.TabloAdi'),FieldType:"text"},
            Aktif:{FieldName:"Aktif",Field:"checkbox",FieldTitle:this.$t('StrIcDegerTablo.AddEdit.Aktif'),FieldType:"text"}, 
            Sirano:{FieldName:"Sirano",Field:"input",FieldTitle:this.$t('StrIcDegerTablo.AddEdit.SiraNo')},
            Olgunluk1:{FieldName:"Olgunluk1",Field:"input",FieldTitle:this.$t('StrIcDegerTablo.AddEdit.Olgunluk1')},
            Olgunluk2:{FieldName:"Olgunluk2",Field:"input",FieldTitle:this.$t('StrIcDegerTablo.AddEdit.Olgunluk2')},
            Olgunluk3:{FieldName:"Olgunluk3",Field:"input",FieldTitle:this.$t('StrIcDegerTablo.AddEdit.Olgunluk3')},
            Olgunluk4:{FieldName:"Olgunluk4",Field:"input",FieldTitle:this.$t('StrIcDegerTablo.AddEdit.Olgunluk4')}, 
            Olgunluk5:{FieldName:"Olgunluk5",Field:"input",FieldTitle:this.$t('StrIcDegerTablo.AddEdit.Olgunluk5')},
            Aciklama:{FieldName:"Aciklama",Field:"textarea",FieldTitle:this.$t('StrIcDegerTablo.AddEdit.Aciklama')},
            Degerlendirmetur:{FieldName:"Degerlendirmetur",Field:"combobox",FieldTitle:this.$t('StrIcDegerTablo.AddEdit.Degerlendirmetur'),ComboDataArray:[]}
          } ,
          Degerlendirmeturleri:[
            {"id":"1","value":"Kalite Öz Değerlendirme"},
            {"id":"2","value":"Akran Değerlendirme"},
            {"id":"3","value":"Program Öz Değerlendirme"},
            {"id":"4","value":"İç Değerlendirme"}
  
          ],
      }
    }, 
    validations:{ 
      FormData: {  
        Tabloadi: { required },  
        Aktif: {  }, 
        Sirano: {  },  
        Olgunluk1: {  }, 
        Olgunluk2: {  }, 
        Olgunluk3: {  }, 
        Olgunluk4: {  }, 
        Olgunluk5: {  }, 
        Aciklama: {  },
        Degerlendirmetur: { }
      }
 
  },
  created(){
    this.FormDataType.Degerlendirmetur.ComboDataArray=[];
      for (var n=0 ; n<this.Degerlendirmeturleri.length; n++){

          this.FormDataType.Degerlendirmetur.ComboDataArray.push ({Id:this.Degerlendirmeturleri[n].id,Value:this.Degerlendirmeturleri[n].value})


      }
  }
}
export default StrIcDegerTablo